// 3rd party imports
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';

// mobx
import { AuthState } from 'sources';
import { UserAuthStore } from 'stores';

interface SignoutProps {
  history?: any;
  userAuth: UserAuthStore;
}

@inject('userAuth')
@observer
class SignoutComponent extends React.Component<SignoutProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    if (this.props.userAuth.authenticated === AuthState.UNKNOWN) {
      return null;
    }

    const homePath = '/';

    if (this.props.userAuth.authenticated === AuthState.TRUE) {
      this.props.userAuth.logout(homePath);
    } else {
      this.props.history.replace(homePath);
    }

    return null;
  }
}
export const Signout = withRouter(SignoutComponent);
